import axios from "axios";

// Helper to get language headers
const getLang = () => localStorage.getItem("lang") || "en";

const getLanguageHeaders = () => {
  const lang = getLang();
  return {
    "Accept-Language": lang,              // "en" or "ar"
    "Language-ID": lang === "ar" ? 4 : 1, // 4 for Arabic, 1 for English
  };
};

/**
 * Verify a coupon code
 * @param {string} code - The coupon code to verify
 * @returns {Promise<object>} - The verification response
 */
export const verifyCoupon = async (code) => {
  const storeId =
    localStorage.getItem("storeId") ||
    localStorage.getItem("store_id") ||
    693877; // Fallback store ID

  const headers = {
    ...getLanguageHeaders(),
    "Store-ID": storeId,
  };

  // Using the exact structure requested by the user
  const response = await axios.post(
    `${process.env.REACT_APP_API_POS_WITH_WEBSITE}/api/oc/coupons/verify/`,
    { code },
    { headers }
  );

  return response.data;
};
